// ink-component
import React, { HTMLProps } from 'react';

import getGlobalProps from '../../../../helpers/constants/global-props';

import Column from '../../../Grid/Column/Column';

export interface PageSidebarProps extends HTMLProps<HTMLDivElement> {}

const globalProps = getGlobalProps({});

/**
 * @purpose Displays page navigation or complementary information
 * @group Page
 */
function PageSidebar(props: PageSidebarProps) {
  const { className, style, ...otherProps } = props;
  return (
    <Column mobile="3-of-12" desktop="2-of-12">
      <aside {...otherProps} {...globalProps} />
    </Column>
  );
}

PageSidebar.displayName = 'Page.Sidebar';

export default PageSidebar;
